import React, { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import Modal from '../../../../../shared/components/Modal'
import IMotorista from '../../../domain/entities/IMotorista'
import { Field, Title, Value } from './styles'

interface IDetalhesMotorista {
  motorista: IMotorista
  open: boolean
  setOpenModal(): void
}

const DetalhesMotorista: FunctionComponent<IDetalhesMotorista> = ({
  motorista,
  open,
  setOpenModal,
}) => {
  return (
    <Modal openModal={open} onCloseModal={setOpenModal} size="large">
      <Grid container>
        <Grid item xs={12}>
          <Title>Dados do motorista</Title>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Nome do motorista</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>Nº da CNH</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>Vencimento da CNH</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.nome}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.cnh}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.vencimento_cnh}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Categoria</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>CPF</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>RG</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.categoria_cnh}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.cpf}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.rg}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Local de nascimento</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{`${motorista.local_emissao_cnh} - ${motorista.estado_emissao_cnh}`}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Title>Telefone</Title>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Celular</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.telefone}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Email</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.email}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Title>Endereço</Title>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>CEP</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.endereco.cep}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Logradouro</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>Número</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>Bairro</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.endereco.logradouro}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.endereco.numero}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.endereco.bairro}</Value>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Field>Cidade</Field>
        </Grid>
        <Grid item xs={4}>
          <Field>Estado</Field>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <Value>{motorista.endereco.cidade}</Value>
        </Grid>
        <Grid item xs={4}>
          <Value>{motorista.endereco.estado}</Value>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default DetalhesMotorista
